import {Calculator} from './Calculator';

export function CalculatorManager() {
  return (<Calculator />);
}
